import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';
// tslint:disable-next-line:import-name
import ReactImageFallback from 'react-image-fallback';

export interface IMenuProductImageProps {
    imageUrl: string;
    imagePlaceHolder: string;
    imageAltText?: string;
}

export interface IMenuProductImageState {
}

export default class MenuProductImage extends Component<IMenuProductImageProps, IMenuProductImageState> {
    static propTypes = {
        imageUrl: PropTypes.string,
        imageAltText: PropTypes.string
    };

    static defaultProps = {
        imageUrl: '',
        imagePlaceHolder: 'https://247windscreens.co.uk/wp-content/uploads/2014/06/Bills_to_pay_icons-07-5121.png',
        imageAltText: 'image'
    };

    render() {
        const {
            imageUrl,
            imageAltText,
            imagePlaceHolder
        } = this.props;

        return (
            <ReactImageFallback
                src={imageUrl}
                alt={imageAltText}
                fallbackImage={imagePlaceHolder} />
        );
    }
}
